import React from 'react'
import YnsIcon from '../../../icons/YnsIcon'
import { getCoachAvatarUrl } from './getCoachAvatarUrl'

/**
 * Busy / soft-unavailable coach card — shared by modal list and video-frame picker.
 */
function BusyCoachCard({
  coach,
  jobTitle,
  busyMessage,
  showPauseIcon = true,
  grayscaleAvatar = true,
}) {
  return (
    <div className="coach-row-content card relative block rounded-2.5xl border border-gray-300 bg-gray-50 opacity-75 shadow-md @container">
      <div className="grid grid-cols-1 items-center gap-4 p-4 @md:grid-cols-[auto_1fr_auto]">
        <div className="flex w-full flex-col items-center self-end @md:-mb-4 @md:mt-[-40px] @md:w-auto">
          <img
            src={getCoachAvatarUrl(coach)}
            alt={coach.displayName}
            className={`h-30 w-28 object-contain ${grayscaleAvatar ? 'grayscale' : ''}`}
          />
        </div>
        <div className="flex flex-col items-center @md:items-start">
          <strong className="text-gray-700">{coach.displayName}</strong>
          <span className="text-gray-600">{jobTitle}</span>
          <span className="mt-1 text-sm font-medium text-orange-600">
            {busyMessage}
          </span>
        </div>
        <div className="flex items-center justify-center gap-2 @md:justify-start">
          {showPauseIcon && (
            <span className="flex h-10 w-10 cursor-not-allowed items-center justify-center rounded-full border border-gray-400 bg-gray-200 text-gray-500">
              <YnsIcon name="pause" className="h-6 w-6" />
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default BusyCoachCard
